module.exports = __webpack_public_path__ + "img/i-3.1c877a18.jpg";